import React from 'react';
import * as Styled from './styled';
import { BlockedRegionContentContainer } from './styled';
import { ARIA_LABELS, REGION_BLOCKED_TEXT, REGION_BLOCKED_TITLE, TEST_IDS } from './constants';
import { handleButtonClick } from './utils';
import { getSiteColor } from '../../utils/getSiteColor';
export var BlockedRegionContent = function BlockedRegionContent(_ref) {
  var siteName = _ref.siteName,
    environment = _ref.environment,
    onClickNoThanks = _ref.onClickNoThanks;
  return /*#__PURE__*/React.createElement(BlockedRegionContentContainer, {
    role: "dialog",
    "aria-labelledby": "blocked-region-title",
    "aria-describedby": "blocked-region-text"
  }, /*#__PURE__*/React.createElement(Styled.BlockedRegionTitle, {
    id: "blocked-region-title"
  }, REGION_BLOCKED_TITLE), /*#__PURE__*/React.createElement(Styled.BlockedRegionText, {
    id: "blocked-region-text"
  }, REGION_BLOCKED_TEXT), /*#__PURE__*/React.createElement(Styled.ActionButtons, null, /*#__PURE__*/React.createElement(Styled.NoThanksButton, {
    onClick: function onClick() {
      return handleButtonClick(false, environment, onClickNoThanks);
    },
    "data-testid": TEST_IDS.NO_THANKS_BUTTON,
    "aria-label": ARIA_LABELS.NO_THANKS
  }, "No, thanks"), /*#__PURE__*/React.createElement(Styled.SureButton, {
    onClick: function onClick() {
      return handleButtonClick(true, environment, onClickNoThanks);
    },
    "data-testid": TEST_IDS.SURE_BUTTON,
    "aria-label": ARIA_LABELS.SURE,
    buttonStyle: {
      backgroundColor: getSiteColor(siteName)
    }
  }, /*#__PURE__*/React.createElement("p", null, "Sure!"))));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/BlockedRegionContent/index.js
// module id = 2598
// module chunks = 11